import { Injectable } from '@angular/core';
import { translate } from '@jsverse/transloco';


@Injectable({
  providedIn: 'root'
})
export class ToastrErrorService {

  constructor() { }

  errorMessage(error): any {
    let message;
    if (error.message) {
      message = error.message;
    } else if (error.errmsg) {
      message = error.errmsg;
    } else if (error.error.message) {
      message = error.error.message;
    } else if (!error.message && !error.errmsg && !error.error.message && error !=='') {
      if (error.error === translate('ERROR_DIALOG.NOT_FOUND')) {
        message = translate('ERROR_DIALOG.API_NOT_AVAILABLE');
      }
    }
    return message;
  }
}
